import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/LanguageContext';

interface ExamStatusFilterProps {
  selectedExamStatus: string | null;
  selectedQuestionnaireStatus: string | null;
  onExamStatusChange: (status: string | null) => void;
  onQuestionnaireStatusChange: (status: string | null) => void;
  /** #97: shown on the «غير مكتمل» questionnaire filter when known. */
  questionnaireNotCompletedCount?: number;
}

export function ExamStatusFilter({ 
  selectedExamStatus, 
  selectedQuestionnaireStatus, 
  onExamStatusChange, 
  onQuestionnaireStatusChange,
  questionnaireNotCompletedCount
}: ExamStatusFilterProps) {
  const { t } = useLanguage();
  
  const examStatuses = [
    { value: 'exam-completed', label: t('dashboard.examiner.statuses.examCompleted') || 'تم الفحص' },
    { value: 'exam-not-completed', label: t('dashboard.examiner.statuses.examNotCompleted') || 'لم يتم الفحص' }
  ];

  const questionnaireStatuses = [
    { value: 'questionnaire-completed', label: t('dashboard.examiner.statuses.questionnaireCompleted') || 'تم تعبئة الاستبيان' },
    {
      value: 'questionnaire-not-completed',
      label: `${t('dashboard.examiner.statuses.questionnaireNotCompleted') || 'لم يتم تعبئة الإستبيان'}${
        questionnaireNotCompletedCount === undefined ? '' : ` (${questionnaireNotCompletedCount})`
      }`
    }
  ];

  const handleExamStatusClick = (status: string) => {
    onExamStatusChange(selectedExamStatus === status ? null : status);
  };

  const handleQuestionnaireStatusClick = (status: string) => {
    onQuestionnaireStatusChange(selectedQuestionnaireStatus === status ? null : status);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {examStatuses.map((status) => (
        <button
          key={status.value}
          onClick={() => handleExamStatusClick(status.value)}
          className="focus:outline-none"
        >
          <Badge
            variant={selectedExamStatus === status.value ? 'default' : 'outline'}
            className={cn(
              'cursor-pointer',
              selectedExamStatus === status.value && 'bg-[#7dda55] hover:bg-[#6dc447] text-white'
            )}
          >
            {status.label}
          </Badge>
        </button>
      ))}
      {questionnaireStatuses.map((status) => (
        <button
          key={status.value}
          onClick={() => handleQuestionnaireStatusClick(status.value)}
          className="focus:outline-none"
        >
          <Badge
            variant={selectedQuestionnaireStatus === status.value ? 'default' : 'outline'}
            className={cn(
              'cursor-pointer',
              selectedQuestionnaireStatus === status.value && 'bg-[#004250] hover:bg-[#003240] text-white'
            )}
          >
            {status.label}
          </Badge>
        </button>
      ))}
    </div>
  );
}